import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=50b8a9b8&scoped=true&"
import script from "./MiniCart.vue?vue&type=script&lang=js&"
export * from "./MiniCart.vue?vue&type=script&lang=js&"
import style0 from "./MiniCart.vue?vue&type=style&index=0&id=50b8a9b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b8a9b8",
  null
  
)

/* custom blocks */
import block0 from "@/locales/minicart.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2FNavigation%2FMiniCart%2FMiniCart.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports